import { ContactInfo, SDGGoal } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const companyInfo: ContactInfo = {
  company: 'SojaTerra',
  location: 'Planalto Central, Província do Bié, Angola',
  email: 'contacto@sojaterra.ao',
  phone: '+244 XXX XXX XXX',
  website: 'www.sojaterra.ao',
  socialMedia: {
    linkedin: 'https://linkedin.com/company/sojaterra',
    facebook: 'https://facebook.com/sojaterra',
  },
};

export const operationalModel = [
  {
    title: 'Produção Mecanizada',
    description: 'Implementação de tecnologia agrícola moderna com equipamentos especializados para cultivo sustentável de soja no Planalto Central.',
    icon: IMAGES.AGRICULTURAL_MACHINERY_1,
  },
  {
    title: 'Gestão Técnica Especializada',
    description: 'Equipa multidisciplinar com expertise em agronomia, gestão de operações e desenvolvimento sustentável de cadeias produtivas.',
    icon: IMAGES.SOYBEAN_FIELD_1,
  },
  {
    title: 'Crescimento Progressivo',
    description: 'Implementação faseada com foco em consolidação operacional, aprendizagem contínua e expansão estruturada da capacidade produtiva.',
    icon: IMAGES.AFRICAN_AGRICULTURE_1,
  },
  {
    title: 'Infraestrutura Agrícola',
    description: 'Desenvolvimento de sistemas de armazenamento, logística e processamento alinhados com padrões internacionais de qualidade.',
    icon: IMAGES.GRAIN_STORAGE_1,
  },
];

export const sdgGoals: SDGGoal[] = [
  {
    number: 2,
    title: 'Fome Zero e Agricultura Sustentável',
    description: 'Contribuição para a segurança alimentar nacional através da produção estruturada de proteína vegetal e fortalecimento da cadeia agrícola.',
    icon: IMAGES.SDG_ICONS_1_63,
  },
  {
    number: 8,
    title: 'Trabalho Decente e Crescimento Económico',
    description: 'Geração de emprego qualificado no interior de Angola, desenvolvimento de competências técnicas e criação de valor económico regional.',
    icon: IMAGES.SDG_ICONS_2_64,
  },
  {
    number: 9,
    title: 'Indústria, Inovação e Infraestrutura',
    description: 'Implementação de tecnologia agrícola moderna, desenvolvimento de infraestrutura produtiva e fortalecimento da cadeia de valor.',
    icon: IMAGES.SDG_ICONS_3_65,
  },
  {
    number: 12,
    title: 'Consumo e Produção Responsáveis',
    description: 'Práticas agrícolas sustentáveis, gestão eficiente de recursos naturais e compromisso com a preservação ambiental do Planalto Central.',
    icon: IMAGES.SDG_ICONS_4_66,
  },
];

export const sustainabilityCommitments = [
  {
    title: 'Alinhamento com o Plano Nacional de Desenvolvimento',
    description: 'Contribuição estratégica para a diversificação económica de Angola, fortalecimento da segurança alimentar e desenvolvimento do interior do país.',
  },
  {
    title: 'Desenvolvimento Regional Sustentável',
    description: 'Foco no crescimento económico da Província do Bié através da criação de emprego, transferência de conhecimento técnico e fortalecimento da cadeia produtiva local.',
  },
  {
    title: 'Gestão Ambiental Responsável',
    description: 'Implementação de práticas agrícolas que preservam os recursos naturais do Planalto Central, com foco em gestão sustentável do solo e uso eficiente de água.',
  },
  {
    title: 'Capacitação e Desenvolvimento Humano',
    description: 'Investimento na formação técnica de profissionais angolanos, criação de oportunidades para jovens e fortalecimento das competências locais no setor agrícola.',
  },
];
